module.exports = __webpack_public_path__ + "img/35.129e781f.png";